<img
  src="../../../../assets/img/logo.svg"
  alt="Logo"
  class="logo" />
